import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {Utils} from '@astek/utils';
import {healthCenterValidator} from '../services/validator/health-center.validator';
import {HealthCenterShort} from '../../health-center/services/http/health-center-short';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {HealthCenterSelectDialogData} from './health-center-select-dialog-data';
import {filter, map, startWith} from 'rxjs';
import {HealthCentreService} from '../../health-center/services/health-centre.service';

@Component({
  selector: 'xp-health-center-select-dialog',
  templateUrl: './health-center-select-dialog.component.html',
  styleUrls: [
    '../../crud.common.scss',
    '../../../shared/components/dialog.common.scss',
    './health-center-select-dialog.component.scss',
  ],
})
export class HealthCenterSelectDialogComponent implements OnInit {

  public readonly formGroup = this._formBuilder.group({
    healthCenter: [null],
  }, {validators: [healthCenterValidator]});

  public isLoading: boolean = false;
  public errorKey: string = '';
  public filteredHealthCenters: Array<HealthCenterShort> = [];

  constructor(
    private readonly _dialogRef: MatDialogRef<HealthCenterSelectDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: HealthCenterSelectDialogData,
    private readonly _formBuilder: FormBuilder,
    private readonly _healthCenterService: HealthCentreService,
  ) {
  }

  public ngOnInit(): void {
    this.formGroup.controls.healthCenter.valueChanges.pipe(
      startWith(''),
      filter((value: any) => typeof value === 'string'),
      map((value: string) => this._healthCenterService.filterHealthCentreList(this.data.healthCenters, value ?? '')),
    ).subscribe((healthCenters: Array<HealthCenterShort>) => this.filteredHealthCenters = healthCenters);

  }

  public healthCenterToString(healthCenter: HealthCenterShort | null): string {
    if (Utils.isNullOrUndefined(healthCenter)) {
      return '';
    }
    return healthCenter.toString();
  }

  public onSubmit(): void {
    if (this.formGroup.invalid ||
      Utils.isNullOrUndefined(this.formGroup.controls.healthCenter.value)
    ) {
      return;
    }
    this.isLoading = true;
    this.errorKey = '';

    this._dialogRef.close(this.formGroup.controls.healthCenter.value as HealthCenterShort);
  }
}
